/* eslint-disable */
import { defineStore } from "pinia";
import { auth, db } from "@/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore"; // setDoc eklendi
import { ref } from "vue";

export const useUserStore = defineStore("user", {
  state: () => ({
    userData: null,
    userProfile: null, // Detaylı profil bilgileri için
    loading: false,
    isProfileLoaded: false, // Profil bilgilerinin yüklenip yüklenmediğini kontrol etmek için
  }),

  actions: {
    // Kullanıcı verilerini Firestore'a kaydet
    async setUserData(uid, data) {
      if (!uid) return;

      this.loading = true;
      try {
        // Kullanıcı dökümanını Firestore'a kaydet
        await setDoc(doc(db, "users", uid), data);
        // Başarıyla kaydedildiğinde store'daki userData'yı güncelle
        this.userData = data;
        return true;
      } catch (error) {
        console.error("Error setting user data:", error);
        throw error;
      } finally {
        this.loading = false;
      }
    },

    // Temel kullanıcı verilerini al
    async fetchUserData(uid) {
      if (!uid) return;

      this.loading = true;
      try {
        const userDoc = await getDoc(doc(db, "users", uid));
        if (userDoc.exists()) {
          this.userData = userDoc.data();
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        this.loading = false;
      }
    },

    // Detaylı profil bilgilerini al
    async fetchUserProfile(uid) {
      if (!uid || this.isProfileLoaded) return; // Eğer profil zaten yüklendiyse tekrar yükleme

      this.loading = true;
      try {
        // Ana kullanıcı ve account dökümanlarını parallel olarak al
        const [userDoc, propertiesDoc, petAccountDoc, serviceAccountDoc] =
          await Promise.all([
            getDoc(doc(db, "users", uid)),
            getDoc(doc(db, "users", uid, "account", "properties")),
            getDoc(doc(db, "users", uid, "account", "pet_account")),
            getDoc(doc(db, "users", uid, "account", "service_account")),
          ]);

        if (userDoc.exists()) {
          const userData = userDoc.data();

          this.userProfile = {
            ...userData,
            account: {
              properties: propertiesDoc.exists()
                ? propertiesDoc.data()
                : { type: "Member" },
              pet_account: petAccountDoc.exists()
                ? petAccountDoc.data()
                : { type: "Personal" },
              service_account: serviceAccountDoc.exists()
                ? serviceAccountDoc.data()
                : { type: "Personal" },
            },
          };

          this.userData = userData; // Temel bilgileri de güncelle
          this.isProfileLoaded = true; // Profil yüklendiğini işaretle
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        this.loading = false;
      }
    },

    // Store'u temizle
    clearUserData() {
      this.userData = null;
      this.userProfile = null;
      this.isProfileLoaded = false;
      this.loading = false;
    },
  },

  getters: {
    // Profil bilgilerini getir
    getProfile: (state) => state.userProfile || state.userData,
  },
});
